import { apiPath } from './api.path';
import { instance } from './axios';

async function addVidoeAPI(params) {
  return instance.post(apiPath.addVideo, params).then((response) => response.data);
}

async function getVidoeAPI(params) {
  return instance.get(apiPath.getVideo, params).then((response) => response.data);
}

async function getVideoDetailAPI(params) {
  return instance.get(`${apiPath.videoDetail}/${params}`).then((response) => response.data);
}

async function deleteVideoAPI(params) {
  return instance.delete(`${apiPath.deleteVideo}?videoId=${params}`).then((response) => response.data);
}

async function updateVideoAPI(params) {
  return instance.put(apiPath.updateVideo, params).then((response) => response.data);
}

const videoService = {
  getVidoeAPI,
  addVidoeAPI,
  getVideoDetailAPI,
  deleteVideoAPI,
  updateVideoAPI
};

export default videoService;
